import { useStaticQuery } from '../../../helpers/useStaticData';
import { getArticlesResponse } from '../../../helpers/data';

export const useGetArticleQuery = () => useStaticQuery(() => getArticlesResponse());
